import {
  CheckCircle,
  MinusCircle,
  PageRight,
  XmarkCircle
} from 'iconoir-react';

import { RunDeployment } from '../hooks/useDeploymentsData';

import i18n from '~/common/helpers/i18n';
import { Deployment } from '~/entities/Deployment';

export const REPLICA_WARNING_THRESHOLD = 10;

export const exceedsReplicaWarningThreshold = (
  replicas?: number | string
): boolean => {
  const value = Number(replicas);
  return !Number.isNaN(value) && value > REPLICA_WARNING_THRESHOLD;
};

export type StatusKey =
  | 'deleting'
  | 'starting'
  | 'degraded'
  | 'error'
  | 'deployed'
  | 'service_error'
  | 'service_active';

export type StatusInfo = {
  text: string;
  icon: React.ComponentType<{ className?: string }>;
};

export const transformDeploymentStatus = (
  deployment: Deployment
): Partial<RunDeployment> => {
  const isStatusError = deployment.status === 'SERVICE_ERROR';

  const statusFormated =
    deployment.status.substring(0, 1) +
    deployment.status.substring(1).toLowerCase();

  return {
    ...deployment,
    status: {
      text: isStatusError ? 'Error' : statusFormated
    }
  } as Partial<RunDeployment>;
};

export const getStatusParamValue = (
  status: string | string[] | null
): string[] => {
  if (!status || status === 'null') return [];

  if (Array.isArray(status)) return status;

  if (typeof status === 'string' && status.includes(',')) {
    return status.split(',').filter(s => s !== '');
  }

  if (status?.length > 0) return [status];

  return [];
};

export const getMessageStatus = ({
  deployStatus
}: {
  deployStatus?: StatusKey;
}): StatusInfo => {
  const statusMap = {
    deleting: {
      text: i18n.t('label.deleting'),
      icon: MinusCircle
    },
    starting: {
      text: i18n.t('label.starting'),
      icon: PageRight
    },
    degraded: {
      text: i18n.t('label.starting'),
      icon: PageRight
    },
    error: {
      text: i18n.t('label.error'),
      icon: XmarkCircle
    },
    deployed: {
      text: i18n.t('label.deployed'),
      icon: CheckCircle
    },
    service_error: {
      text: i18n.t('label.error'),
      icon: XmarkCircle
    },
    service_active: {
      text: i18n.t('label.deployed'),
      icon: CheckCircle
    }
  };

  const statusSelected = deployStatus;
  if (statusSelected && statusSelected in statusMap) {
    return statusMap[statusSelected as StatusKey];
  }
  return statusMap.deployed;
};
